var _style, _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanderaUsa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.44 173.84",
    style: {
      enableBackground: "new 0 0 275.44 173.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000164484870114300259000000002722333093594486448_);}\n\t.st1{fill:#E30613;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#29235C;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M242.46,158.06H32.98c-9.07,0-16.42-7.35-16.42-16.42V32.19c0-9.07,7.35-16.42,16.42-16.42h209.48 c9.07,0,16.42,7.35,16.42,16.42v109.45C258.88,150.71,251.53,158.06,242.46,158.06z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056394940617683282380000004749874810595170706_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056394940617683282380000004749874810595170706_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 15.78,
    className: "st1",
    width: 242.32,
    height: 12.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 28.71,
    className: "st2",
    width: 242.32,
    height: 12.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 41.65,
    className: "st1",
    width: 242.32,
    height: 12.94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 54.58,
    className: "st2",
    width: 242.32,
    height: 12.94
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 67.52,
    className: "st1",
    width: 242.32,
    height: 12.94
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 80.45,
    className: "st2",
    width: 242.32,
    height: 12.94
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 93.39,
    className: "st1",
    width: 242.32,
    height: 12.94
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 106.32,
    className: "st2",
    width: 242.32,
    height: 12.94
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 119.26,
    className: "st1",
    width: 242.32,
    height: 12.94
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 132.19,
    className: "st2",
    width: 242.32,
    height: 12.94
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 145.13,
    className: "st1",
    width: 242.32,
    height: 12.94
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 15.78,
    className: "st3",
    width: 121.16,
    height: 90.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.88,21.12 30.47,24.34 34.03,24.86 31.45,27.37 32.06,30.91 28.88,29.24 25.7,30.91 26.31,27.37  23.73,24.86 27.29,24.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.97,21.12 46.56,24.34 50.11,24.86 47.54,27.37 48.15,30.91 44.97,29.24 41.79,30.91  42.39,27.37 39.82,24.86 43.38,24.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.05,21.12 62.64,24.34 66.2,24.86 63.63,27.37 64.23,30.91 61.05,29.24 57.87,30.91 58.48,27.37  55.91,24.86 59.46,24.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.14,21.12 78.73,24.34 82.29,24.86 79.71,27.37 80.32,30.91 77.14,29.24 73.96,30.91  74.57,27.37 71.99,24.86 75.55,24.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.23,21.12 94.82,24.34 98.37,24.86 95.8,27.37 96.41,30.91 93.23,29.24 90.05,30.91 90.65,27.37  88.08,24.86 91.64,24.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "109.32,21.12 110.91,24.34 114.46,24.86 111.89,27.37 112.5,30.91 109.32,29.24 106.13,30.91  106.74,27.37 104.17,24.86 107.72,24.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.4,21.12 126.99,24.34 130.55,24.86 127.98,27.37 128.58,30.91 125.4,29.24 122.22,30.91  122.83,27.37 120.26,24.86 123.81,24.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.88,35.13 30.47,38.36 34.03,38.87 31.45,41.38 32.06,44.92 28.88,43.25 25.7,44.92 26.31,41.38  23.73,38.87 27.29,38.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.97,35.13 46.56,38.36 50.11,38.87 47.54,41.38 48.15,44.92 44.97,43.25 41.79,44.92  42.39,41.38 39.82,38.87 43.38,38.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.05,35.13 62.64,38.36 66.2,38.87 63.63,41.38 64.23,44.92 61.05,43.25 57.87,44.92 58.48,41.38  55.91,38.87 59.46,38.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.14,35.13 78.73,38.36 82.29,38.87 79.71,41.38 80.32,44.92 77.14,43.25 73.96,44.92  74.57,41.38 71.99,38.87 75.55,38.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.23,35.13 94.82,38.36 98.37,38.87 95.8,41.38 96.41,44.92 93.23,43.25 90.05,44.92 90.65,41.38  88.08,38.87 91.64,38.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "109.32,35.13 110.91,38.36 114.46,38.87 111.89,41.38 112.5,44.92 109.32,43.25 106.13,44.92  106.74,41.38 104.17,38.87 107.72,38.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.4,35.13 126.99,38.36 130.55,38.87 127.98,41.38 128.58,44.92 125.4,43.25 122.22,44.92  122.83,41.38 120.26,38.87 123.81,38.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.88,49.15 30.47,52.37 34.03,52.89 31.45,55.4 32.06,58.94 28.88,57.26 25.7,58.94 26.31,55.4  23.73,52.89 27.29,52.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.97,49.15 46.56,52.37 50.11,52.89 47.54,55.4 48.15,58.94 44.97,57.26 41.79,58.94 42.39,55.4  39.82,52.89 43.38,52.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.05,49.15 62.64,52.37 66.2,52.89 63.63,55.4 64.23,58.94 61.05,57.26 57.87,58.94 58.48,55.4  55.91,52.89 59.46,52.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.14,49.15 78.73,52.37 82.29,52.89 79.71,55.4 80.32,58.94 77.14,57.26 73.96,58.94 74.57,55.4  71.99,52.89 75.55,52.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.23,49.15 94.82,52.37 98.37,52.89 95.8,55.4 96.41,58.94 93.23,57.26 90.05,58.94 90.65,55.4  88.08,52.89 91.64,52.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "109.32,49.15 110.91,52.37 114.46,52.89 111.89,55.4 112.5,58.94 109.32,57.26 106.13,58.94  106.74,55.4 104.17,52.89 107.72,52.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.4,49.15 126.99,52.37 130.55,52.89 127.98,55.4 128.58,58.94 125.4,57.26 122.22,58.94  122.83,55.4 120.26,52.89 123.81,52.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.88,63.16 30.47,66.38 34.03,66.9 31.45,69.41 32.06,72.95 28.88,71.28 25.7,72.95 26.31,69.41  23.73,66.9 27.29,66.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.97,63.16 46.56,66.38 50.11,66.9 47.54,69.41 48.15,72.95 44.97,71.28 41.79,72.95 42.39,69.41  39.82,66.9 43.38,66.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.05,63.16 62.64,66.38 66.2,66.9 63.63,69.41 64.23,72.95 61.05,71.28 57.87,72.95 58.48,69.41  55.91,66.9 59.46,66.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.14,63.16 78.73,66.38 82.29,66.9 79.71,69.41 80.32,72.95 77.14,71.28 73.96,72.95 74.57,69.41  71.99,66.9 75.55,66.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.23,63.16 94.82,66.38 98.37,66.9 95.8,69.41 96.41,72.95 93.23,71.28 90.05,72.95 90.65,69.41  88.08,66.9 91.64,66.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "109.32,63.16 110.91,66.38 114.46,66.9 111.89,69.41 112.5,72.95 109.32,71.28 106.13,72.95  106.74,69.41 104.17,66.9 107.72,66.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.4,63.16 126.99,66.38 130.55,66.9 127.98,69.41 128.58,72.95 125.4,71.28 122.22,72.95  122.83,69.41 120.26,66.9 123.81,66.38  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.88,77.18 30.47,80.4 34.03,80.92 31.45,83.42 32.06,86.97 28.88,85.29 25.7,86.97 26.31,83.42  23.73,80.92 27.29,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.97,77.18 46.56,80.4 50.11,80.92 47.54,83.42 48.15,86.97 44.97,85.29 41.79,86.97 42.39,83.42  39.82,80.92 43.38,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.05,77.18 62.64,80.4 66.2,80.92 63.63,83.42 64.23,86.97 61.05,85.29 57.87,86.97 58.48,83.42  55.91,80.92 59.46,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.14,77.18 78.73,80.4 82.29,80.92 79.71,83.42 80.32,86.97 77.14,85.29 73.96,86.97 74.57,83.42  71.99,80.92 75.55,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.23,77.18 94.82,80.4 98.37,80.92 95.8,83.42 96.41,86.97 93.23,85.29 90.05,86.97 90.65,83.42  88.08,80.92 91.64,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "109.32,77.18 110.91,80.4 114.46,80.92 111.89,83.42 112.5,86.97 109.32,85.29 106.13,86.97  106.74,83.42 104.17,80.92 107.72,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.4,77.18 126.99,80.4 130.55,80.92 127.98,83.42 128.58,86.97 125.4,85.29 122.22,86.97  122.83,83.42 120.26,80.92 123.81,80.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "28.88,91.19 30.47,94.41 34.03,94.93 31.45,97.44 32.06,100.98 28.88,99.31 25.7,100.98  26.31,97.44 23.73,94.93 27.29,94.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "44.97,91.19 46.56,94.41 50.11,94.93 47.54,97.44 48.15,100.98 44.97,99.31 41.79,100.98  42.39,97.44 39.82,94.93 43.38,94.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.05,91.19 62.64,94.41 66.2,94.93 63.63,97.44 64.23,100.98 61.05,99.31 57.87,100.98  58.48,97.44 55.91,94.93 59.46,94.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.14,91.19 78.73,94.41 82.29,94.93 79.71,97.44 80.32,100.98 77.14,99.31 73.96,100.98  74.57,97.44 71.99,94.93 75.55,94.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.23,91.19 94.82,94.41 98.37,94.93 95.8,97.44 96.41,100.98 93.23,99.31 90.05,100.98  90.65,97.44 88.08,94.93 91.64,94.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "109.32,91.19 110.91,94.41 114.46,94.93 111.89,97.44 112.5,100.98 109.32,99.31 106.13,100.98  106.74,97.44 104.17,94.93 107.72,94.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.4,91.19 126.99,94.41 130.55,94.93 127.98,97.44 128.58,100.98 125.4,99.31 122.22,100.98  122.83,97.44 120.26,94.93 123.81,94.41  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanderaUsa);
export default __webpack_public_path__ + "static/media/bandera_usa.657552679d411751aaf9e8d511dca717.svg";
export { ForwardRef as ReactComponent };